import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chip", "count"]
  static values = { url: String }

  toggle(event) {
    const chip = event.currentTarget
    chip.classList.toggle("contact-detail__suggestion--added")

    const selected = this.chipTargets
      .filter(c => c.classList.contains("contact-detail__suggestion--added"))
      .map(c => c.dataset.circleName)

    if (this.hasCountTarget) {
      this.countTarget.textContent = `(${selected.length})`
      this.countTarget.toggleAttribute("hidden", selected.length === 0)
    }

    this.save(selected)
  }

  async save(circleNames) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const formData = new FormData()
    formData.append("contact[circle_names]", circleNames.join(", "))
    formData.append("_method", "patch")

    try {
      await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Accept": "text/html"
        },
        body: formData,
        credentials: "same-origin"
      })
    } catch (e) {
      console.error("Failed to update circles", e)
    }
  }
}
